module.exports = __webpack_public_path__ + "static/media/in-transit.5d7d726b.svg";